import colors from "../../../../appConfig/colors";
import { makeStyles } from "@material-ui/core/styles";

const HistoricalResultTableStyle = makeStyles((theme) => ({
	sectionTypography: {
		marginTop: 40,
		fontWeight: 700,
		color: colors.charcoalGray,
		marginBottom: 10,
	},
	tableContainer: {
		position: "relative",
		overflowX: "auto",
		whiteSpace: "nowrap",
	},
	loaderContainer: {
		position: "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		height: "100%",
		zIndex: 10,
	},
	tableHeader: {
		background: colors.primary,
		color: colors.white,
		fontWeight: 600,
	},
	loadingTable: {
		opacity: 0.5,
		pointerEvents: "none",
	},
	progressCell: {
		alignItems: "center",
		flexDirection: "column",
		justifyContent: "center",
	},
	linerProgress: {
		height: 8,
		borderRadius: 4,
		width: "100%",
	},
	progressValue: {
		marginLeft: 8,
		fontSize: 13,
		width: "100%",
		justifyContent: "center",
		display: "flex",
	},
	statusText: {
		fontWeight: 600,
		fontSize: 14,
	},
	actionContainor: {
		whiteSpace: "nowrap",
		overflowX: "auto",
		width: "100%",
	},
	actionButton: {
		marginRight: 8,
		textTransform: "none",
	},
	activeActionButton: {
		background: `${colors.primary} !important`,
		color: `${colors.white} !important`,
		marginRight: 8,
		textTransform: "none",
		opacity: 1,
		"&:hover": {
			backgroundColor: `${colors.darkCrimsonRed} !important`,
		},
	},
	inactiveActionButton: {
		background: `${colors.primary} !important`,
		color: `${colors.white} !important`,
		marginRight: 8,
		textTransform: "none",
		opacity: 0.6,
		"&:hover": {
			backgroundColor: `${colors.darkCrimsonRed} !important`,
		},
	},
}));

export default HistoricalResultTableStyle;
